import { Box, Card, CardContent, Divider, FormControlLabel, FormGroup, Grid, List, ListItem, Switch, Typography, Tabs, Tab, Icon, IconButton } from '@mui/material';
import CommonLayout from 'layouts/DashboardLayout';
import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router';
import { useSearchParams } from 'react-router-dom';
import Users from './Users';
import RolesPermissionsIndex from './RolesPermission';
import { hasSectionPermission } from 'utilities/common';
import { getPermissionsByMode } from 'utilities/common';
import { getData } from 'utilities/common';

export default function RolesPermissions() {
  const [searchParams, setSearchParams] = useSearchParams();
  const fullRoleTab = useMemo(() => searchParams.get('roleTab'), [searchParams]);

  useEffect(() => {
    setSearchParams({ roleTab: fullRoleTab ? fullRoleTab : 'users' })
  }, [fullRoleTab])

  let localUser = getData('login-user-info')
  if (localUser) {
      localUser = JSON.parse(localUser)
  }

  const adminMode = localStorage.getItem("adminsMode") ? JSON.parse(localStorage.getItem("adminsMode")) : null;
  const permissionsForMode = getPermissionsByMode(localUser?.permissions, adminMode);

  const canCreate = hasSectionPermission(permissionsForMode, "Settings", "Create");
  const canEdit = hasSectionPermission(permissionsForMode, "Settings", "Edit/Update");
  const canView = hasSectionPermission(permissionsForMode, "Settings", "View Only");
  const canDelete = hasSectionPermission(permissionsForMode, "Settings", "Delete");

  return (
    <CommonLayout>
      <Box p={{ xs: 2, sm: 3, lg: 4 }} className='roles-permissions-con'>
        <Card sx={{ borderRadius: 2.5, boxShadow: 'none' }}>
          <Tabs
            value={fullRoleTab}
            onChange={(e, newValue) => { setSearchParams({ roleTab: newValue }) }}
            aria-label="users permissions tabs"
          >
            <Tab value="users" label="Users" />
            <Tab value="permissions" label="Permissions" />
          </Tabs>
          <Box p={{ xs: 2, sm: 3, lg: 4 }}>
            {fullRoleTab === 'users' && (
              <Users canView={canView} canDelete={canDelete} canEdit={canEdit} canCreate={canCreate} />
            )}
            {fullRoleTab === 'permissions' && (
              <RolesPermissionsIndex canView={canView} canDelete={canDelete} canEdit={canEdit} canCreate={canCreate} />
            )}
          </Box>
        </Card>
      </Box>
    </CommonLayout>
  );
}

